export const PERMISSIONS = {
  EDIT_AGENTIC_DIAL: 'edit_agentic_dial',
  EDIT_BILLING: 'edit_billing',
  EDIT_DEMAND: 'edit_demand',
  EDIT_GOVERNANCE: 'edit_governance',
  EDIT_INTEGRATIONS: 'edit_integrations',
  EDIT_LOOP: 'edit_loop',
  EDIT_OBJECTIVES: 'edit_objectives',
  EDIT_ORGANIZATION: 'edit_organization',
  EDIT_PLANNER: 'edit_planner',
  EDIT_RECOMMENDATIONS: 'edit_recommendations',
  EDIT_TEAMS: 'edit_teams',
  EDIT_WORKER_TYPE: 'edit_worker_type',
  EVALUATE_DEMAND: 'evaluate_demand',
  VIEW_AGENTIC_DIAL: 'view_agentic_dial',
  VIEW_AUDIT_LOG: 'view_audit_log',
  VIEW_BILLING: 'view_billing',
  VIEW_DEMAND: 'view_demand',
  VIEW_GOVERNANCE: 'view_governance',
  VIEW_INSIGHTS: 'view_insights',
  VIEW_LOOP: 'view_loop',
  VIEW_ORGANIZATION: 'view_organization',
  VIEW_PLANNER: 'view_planner',
  VIEW_RECOMMENDATIONS: 'view_recommendations',
  VIEW_SIGNALS: 'view_signals',
  VIEW_TEAMS: 'view_teams',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
